import React, { useEffect, useImperativeHandle } from 'react';
import { Editor, Frame, Element, useEditor } from '@craftjs/core';
import { Viewport, RenderNode } from '../components/editor';
import { Container, Text, Image, Signature } from '../components/selectors';

const EditorController = React.forwardRef(({ initialContent }, ref) => {
  const { actions, query } = useEditor();
  useEffect(() => {
    if (initialContent) {
      actions.deserialize(initialContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useImperativeHandle(ref, () => ({
    getEditorState: () => {
      return query.serialize();
    },
  }));

  return null;
});


const NewCraftEditor = React.forwardRef(({ 
  initialContent, 
  templateName, 
  onNameChange, 
  onSave, 
  isSaving,
  isLoading,
  isDuplicable, 
  onDuplicableChange,
  isGlobal, 
  onGlobalChange,
  isSuperadmin,
  isEditable = true,
}, ref) => {
    return (
        <div style={{ height: 'calc(100vh - 120px)', width: '100%' }}>
          <Editor 
            resolver={{
              Container,
              Text,
              Image,
              Signature,
            }} 
            enabled={isEditable} 
            onRender={RenderNode}
          >
            <Viewport 
              templateName={templateName}
              onNameChange={onNameChange}
              onSave={onSave}
              isSaving={isSaving}
              isLoading={isLoading}
              isDuplicable={isDuplicable} 
              onDuplicableChange={onDuplicableChange}
              isGlobal={isGlobal} 
              onGlobalChange={onGlobalChange}
              isSuperadmin={isSuperadmin}
            >
              <Frame>
                <Element 
                  canvas 
                  is={Container} 
                  width="100%"
                  minHeight="100%"
                  background={{ r: 255, g: 255, b: 255, a: 1 }} 
                  padding={['40', '40', '40', '40']} 
                  custom={{ displayName: 'App' }} 
                />
              </Frame>
            </Viewport>

            <EditorController ref={ref} initialContent={initialContent} />
          </Editor>
        </div>
    );
});

export default NewCraftEditor;